import React from "react";
import {
  Modal,
  Text,
  Button,
  Group,
  useMantineTheme,
  Divider,
  useComputedColorScheme,
} from "@mantine/core";
import { connect, useDispatch } from "react-redux";
import { closeConfirmation } from "../../utils/redux-utils/actions/actions";
import { useTranslation } from "react-i18next";

function ConfirmationDialog(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const isDark = useComputedColorScheme("light") === "dark";

  const handleConfirm = () => {
    props.onConfirm();
    dispatch(closeConfirmation());
  };
  return (
    <>
      <Modal
        opened={props.isOpen}
        onClose={() => dispatch(closeConfirmation())}
        title={props.title}
        centered
        closeOnClickOutside={props.closable}
        closeOnEscape={props.closable}
        zIndex={1000}
        overlayProps={{
          color: isDark ? theme.colors.dark[9] : theme.colors.gray[2],
          opacity: 0.55,
          blur: 1,
        }}
      >
        <Divider my="sm" />
        <Text>{props.message}</Text>
        <Group justify="flex-end" mt="md">
          {props.closeButtonTitle ? (
            <Button
              variant="default"
              onClick={() => {
                if (props.onClose) props.onClose();
                dispatch(closeConfirmation());
              }}
            >
              {t(props.closeButtonTitle)}
            </Button>
          ) : null}
          {props.confirmButtonTitle ? (
            <Button variant="filled" color="blue" onClick={handleConfirm}>
              {t(props.confirmButtonTitle)}
            </Button>
          ) : null}
        </Group>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    closable: state.dialog.closable,
    closeButtonTitle: state.dialog.closeButtonTitle,
    confirmButtonTitle: state.dialog.confirmButtonTitle,
    isOpen: state.dialog.isOpen,
    title: state.dialog.title,
    message: state.dialog.message,
    onConfirm: state.dialog.onConfirm,
    onClose: state.dialog.onClose,
  };
};

export default connect(mapStateToProps)(ConfirmationDialog);
